declare global {
  interface Window {
    __timelineViewPragmaticDragListenersInstalled?: boolean;
  }
}

/**
 * Force a consistent "move" cursor for any HTML5 drag. Capture-phase listeners
 * with a window-level guard to dedupe across HMR / other Pragmatic views.
 * Call once at module load so the listeners exist before any drag can start.
 */
export function installGlobalDragListeners(): void {
  if (
    typeof document === 'undefined' ||
    window.__timelineViewPragmaticDragListenersInstalled
  ) {
    return;
  }
  window.__timelineViewPragmaticDragListenersInstalled = true;

  document.addEventListener(
    'dragstart',
    (event: DragEvent) => {
      if (event.dataTransfer) {
        event.dataTransfer.effectAllowed = 'move';
      }
    },
    { capture: true }
  );

  const acceptAsMove = (event: DragEvent) => {
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'move';
    }
    event.preventDefault();
  };
  document.addEventListener('dragenter', acceptAsMove, { capture: true });
  document.addEventListener('dragover', acceptAsMove, { capture: true });
}
